import { HeaderMenu, HeaderMenuBreadcrumb } from '@publicisgroupe/p-os-components';
import { ReactNode } from 'react';

interface LayoutHeaderProps {
  breadcrumbs: Array<HeaderMenuBreadcrumb>;
  title: string;
  ctaContent?: ReactNode;
}

export const LayoutHeader = ({ breadcrumbs, title, ctaContent }: LayoutHeaderProps) => {
  return <HeaderMenu breadcrumbs={breadcrumbs} title={title} ctaContent={ctaContent} />;
};
